import { Text, Stack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface CardItemProps {
  label: string;
  value: string | React.ReactNode;
  isMobile?: boolean;
  isLastColumn?: boolean;
  disabled?: boolean;
  width?: string;
}

export const CardItemLoading: React.FC<Partial<CardItemProps>> = ({
  isMobile,
  isLastColumn,
  width,
}) => {
  return (
    <Stack
      direction={isMobile ? 'row' : 'column'}
      justifyContent="space-between"
      flex={isMobile || width ? undefined : 1}
      width={isMobile ? undefined : width}
      padding={width ? Spacing['inline.nano'] : undefined}
      mb={isMobile ? Spacing['stack.quarck'] : 0}
      {...(isLastColumn && { paddingBottom: Spacing['inline.xxs'] })}
      space={Spacing['stack.nano']}>
      <Text isLoading width="30px" height={Typography['fontsize.md']} />
      <Text isLoading width="60px" height={Typography['fontsize.md']} />
    </Stack>
  );
};

export const CardItem: React.FC<CardItemProps> = ({
  label,
  value,
  isMobile,
  isLastColumn,
  disabled,
  width,
}) => {
  const isValueString = typeof value === 'string';
  const color = disabled ? 'neutral.medium' : undefined;

  const renderValue = () => {
    if (isValueString) {
      return <Text color={color}>{value}</Text>;
    }

    return value;
  };

  return (
    <Stack
      direction={isMobile ? 'row' : 'column'}
      justifyContent="space-between"
      flex={isMobile || width ? undefined : 1}
      width={isMobile ? undefined : width}
      padding={width ? Spacing['inline.nano'] : undefined}
      {...(isLastColumn && { paddingBottom: Spacing['inline.xxs'] })}>
      <Text
        paddingBottom={Spacing['inline.quarck']}
        fontSize={Typography['fontsize.md']}
        fontWeight={Typography['fontweight.semibold']}
        color={color}>
        {label}
      </Text>
      {renderValue()}
    </Stack>
  );
};
